var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full",attrs:{"id":"chart_container"}},[_c('CandlesWithDeals',{attrs:{"candles":_vm.candles,"deals":_vm.deals,"pair":_vm.pair.symbol,"candlesChartData":_vm.candlesChartData,"dealsChartData":_vm.dealsChartData,"width":1000}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }